export default __webpack_public_path__ + "static/media/ethereum.6a5400fd.svg";